/** Two document positions `[page, row, column]`; a missing one sorts after any present
 *  one. Shared by `documentOrder` (cards) and `documentOrderFromSummary` (the server's
 *  first positions), so both order regulations by one rule. */
export function comparePosition(
  a: [number, number, number] | null,
  b: [number, number, number] | null,
): number {
  if (!a || !b) return Number(!a) - Number(!b)
  return a[0] - b[0] || a[1] - b[1] || a[2] - b[2]
}
